// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"rhfCheckbox_checkboxContainer__fbhrI"};